import { render, staticRenderFns } from "./PatientVitals.vue?vue&type=template&id=75f41c05&"
import script from "./PatientVitals.vue?vue&type=script&lang=js&"
export * from "./PatientVitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports